import { render, staticRenderFns } from "./TheOperationsBanner.vue?vue&type=template&id=2b12e2a4&scoped=true"
import script from "./TheOperationsBanner.vue?vue&type=script&lang=js"
export * from "./TheOperationsBanner.vue?vue&type=script&lang=js"
import style0 from "./TheOperationsBanner.vue?vue&type=style&index=0&id=2b12e2a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12e2a4",
  null
  
)

export default component.exports